import React from 'react';
import InstitucionalFrame from './InstitucionalFrame';

const InstitucionalHome: React.FC = () => (
  <InstitucionalFrame page="index.html" title="InPlay — O ecossistema completo para quem vive do esporte" />
);

export default InstitucionalHome;
